@let selectedDownload = selectedDownload$ | ngrxPush;
<section
  class="p-0 flex flex-col gap-6"
>
  <section class="p-0" aria-labelledby="page-headline">
    <h1 id="page-headline" class="mu-heading-5 text-petrol-650 pb-2">
      Information zum DATEV-Mittelstand (Freischaltcode)
    </h1>
    <p>
      Hier finden Sie die Freischaltcode-Versionen der
      DATEV-Mittelstand-Produkte.
    </p>

    <p>Haupt-Releases und Service-Releases sind verfügbar für:</p>

    <ul class="list-inside list-disc pl-3">
      <li>DATEV Mittelstand Faktura mit Rechnungswesen compact</li>
      <li>DATEV Mittelstand Faktura</li>
    </ul>
  </section>

  <mat-divider aria-hidden="true"></mat-divider>

  <section class="p-0 flex flex-col gap-12">
    <article class="flex flex-col gap-4">
      <h2 class="mu-heading-5">Haupt-Release</h2>
      <dp-downloads-table
        [dataSource]="mainReleaseDataSource"
        [tableAriaLabel]="'Downloads Mittelstand Haupt-Release'"
        [selectedDownload]="selectedDownload"
        [showLoadMoreButton]="false"
        (onRowSelection)="selectMainRelease($event)"
        [displayedColumns]="['name', 'version', 'published_date']"
      ></dp-downloads-table>
    </article>

    <article class="flex flex-col gap-4">
      <h2 class="mu-heading-5 pb-2">Service-Release</h2>
      <dp-downloads-table
        [dataSource]="serviceReleaseDataSource"
        [tableAriaLabel]="'Downloads Mittelstand Service-Release'"
        [selectedDownload]="selectedDownload"
        [showLoadMoreButton]="false"
        (onRowSelection)="selectServiceRelease($event)"
        [displayedColumns]="['name', 'version', 'published_date']"
      ></dp-downloads-table>
    </article>
    <article class="flex flex-col gap-4">
      <h2 class="mu-heading-5">Archiv Haupt-Releases</h2>
      <dackl-expansion-panel displayMode="light" headline="Archiv">
        <dp-downloads-table
          [dataSource]="mainReleaseArchiveDataSource"
          [tableAriaLabel]="'Archiv Downloads Mittelstand Haupt-Releases'"
          [selectedDownload]="selectedDownload"
          [showLoadMoreButton]="false"
          (onRowSelection)="selectMainRelease($event)"
          [displayedColumns]="['name', 'version', 'published_date']"
        ></dp-downloads-table>
      </dackl-expansion-panel>
    </article>
  </section>
</section>

<ng-template #loading>
  <div class="pt-4 flex content-center justify-center">
    <download-portal-loader></download-portal-loader>
  </div>
</ng-template>

<ng-template #emptyState>
  <dackl-empty-state image="no-matches" size="XS">
    <h2 class="heading-3 mb-2">Keine Daten vorhanden</h2>
    <p class="text-center">Keine Downloads gefunden.</p>
  </dackl-empty-state>
</ng-template>
